export const CONSENT_TEMPLATES_BASE_KEY = 'consent-templates';

export const consentTemplatesApiQueryKeys = {
  all: () => [CONSENT_TEMPLATES_BASE_KEY] as const,
  byId: (id: string) => [CONSENT_TEMPLATES_BASE_KEY, id] as const,
  fileDownloadUrl: (fileId: string) =>
    [CONSENT_TEMPLATES_BASE_KEY, 'files', fileId, 'download-url'] as const,
  variables: () => [CONSENT_TEMPLATES_BASE_KEY, 'variables'],
};
